var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreditCard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 11,
    fill: "none",
    viewBox: "0 0 14 11",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M13.2 3.2995V1.1c0-.6077-.4922-1.1-1.1-1.1h-11C.4923 0 0 .4923 0 1.1v2.1995z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    fillRule: "evenodd",
    d: "M0 4.95V9.9c0 .6078.4923 1.1 1.1 1.1h11c.6078 0 1.1-.4922 1.1-1.1V4.95zm6.05 3.3H2.2v-1.1h3.85zm2.75 0H11v-1.1H8.8z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreditCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/credit-card.1f96a492574cfaef0e0d2044df6486e1.svg";